<template>
  <div class="section haze full-height">
    <div class="wrapper vertical-center">
      <div class="middle" />
      <div class="contact-v1">
        <div class="intro">
          <div class="text-label-2">
            we have liftoff
          </div>
          <h2 class="volk volk-center">
            <span class="text-span-6">Success!</span><br>We Look Forward To Seeing You
          </h2>
          <div class="divider-2 animated" />
          <div>Thanks for signing up. Details on your plan, and a receipt<br>have been sent to {{ accountOwner.email }} Our office will reach out to you to schedule an appointment. If you have any questions or would like to set up your own appointment, don&#x27;t hesitate to call.<a href="#"><br></a><br>If you have any questions call <a href="#"><strong>{{ company.phone }}</strong></a><br>Or visit<a :href="company.website"><strong> Menu.Dental</strong></a></div>
        </div><a
          href="#"
          class="button margin-top w-button"
        >Return To Menu.Dental</a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SignupSuccess',
  props: {
    accountOwner: {
      type: Object,
      default: null,
      required: true
    },
    company: {
      type: Object,
      default: null,
      required: true
    }
  }
}
</script>
